export default __webpack_public_path__ + "static/media/PP_LOGO.76d0bc6f.svg";